var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareGovernance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -1375.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/Governance",
    transform: "translate(3498.000000, 1375.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.921,0 L3.684,0 C3.684,3.909 6.853,7.079 10.763,7.079 L19.916,7.079 L0,26.995 L5.007,32 L24.921,12.085 L24.921,21.237 C24.921,25.146 28.091,28.316 32,28.316 L32,7.079 L32,0 L24.921,0 Z",
    id: 107
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareGovernance);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-governance.e7d15b3d.svg";
export { ForwardRef as ReactComponent };